// One row a lookup question offers (copilot/questions/options). The id is the server's verbatim: a number for records,
// templates, tags, classifications and string values, a guid for users, roles and groups.
export class CopilotQuestionOption {
  id: string;

  label: string;

  description?: string;

  constructor() {
    this.id = '';
    this.label = '';
  }
}

// The narrowing a lookup question names; an empty field narrows nothing
export interface CopilotQuestionOptionFilter {
  tagCategory?: string | number | null;
  stringValueFamily?: string | number | null;
  classificationGroup?: string | number | null;
  nameContains?: string | null;
}
